/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryDto } from '../models/CountryDto';
import type { CurrentCountryDto } from '../models/CurrentCountryDto';
import type { LanguageDto } from '../models/LanguageDto';
import type { ResourcesDto } from '../models/ResourcesDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class ResourcesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CountryDto Success
     * @throws ApiError
     */
    public getV1ResourcesCountries(): CancelablePromise<Array<CountryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resources/countries',
        });
    }
    /**
     * @returns CurrentCountryDto Success
     * @throws ApiError
     */
    public getV1ResourcesCountriesCurrent(): CancelablePromise<CurrentCountryDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resources/countries/current',
        });
    }
    /**
     * @param language
     * @param keys
     * @param timestamp
     * @returns ResourcesDto Success
     * @throws ApiError
     */
    public getV1ResourcesLocalization(
        language: string,
        keys?: Array<string>,
        timestamp?: string,
    ): CancelablePromise<ResourcesDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resources/localization/{language}',
            path: {
                'language': language,
            },
            query: {
                'keys': keys,
                'timestamp': timestamp,
            },
        });
    }
    /**
     * @param keys
     * @param timestamp
     * @returns ResourcesDto Success
     * @throws ApiError
     */
    public getV1ResourcesConfiguration(
        keys?: Array<string>,
        timestamp?: string,
    ): CancelablePromise<ResourcesDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resources/configuration',
            query: {
                'keys': keys,
                'timestamp': timestamp,
            },
        });
    }
    /**
     * @returns LanguageDto Success
     * @throws ApiError
     */
    public getV1ResourcesLanguages(): CancelablePromise<Array<LanguageDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resources/languages',
        });
    }
    /**
     * @returns string Success
     * @throws ApiError
     */
    public getV1ResourcesNews(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resources/news',
        });
    }
}
